export interface IPassMissingRecipientProfile {
    centerId: number,
    medicalRecordId: number,
    firstName: string,
    lastName: string
}